var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BContainer,{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.loading)?_c(_setup.LoadingSpan,{attrs:{"message":_vm.loadingMessage}}):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }